<template>

  <div class="uk-width-1-4@m">
    <a class="uk-align-right uk-button uk-button-secondary uk-button-hollow uk-button-icon uk-button-normal uk-button-tiny-icon uk-hidden@l uk-margin-medium-top button-filters-mobile" uk-toggle="target:#filters-offcanvas">
<!--    <a class="uk-align-right uk-button uk-button-secondary uk-button-hollow uk-button-icon uk-button-normal uk-button-tiny-icon uk-hidden@l uk-margin-medium-top button-filters-mobile" uk-toggle="target:#sidenav; cls:offcanvas-is-visible">-->
      {{ $t('frontend-mtg.area_riservata.ordini.filtra_ordina') }}
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 18.6 18.6" style="enable-background:new 0 0 18.6 18.6;" xml:space="preserve" class="">
        <path id="Shape" class="st0" style="fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;" d="M3.5,10.7V1 M3.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M3.5,10.7c-0.8,0-1.5,0.7-1.5,1.5  s0.7,1.5,1.5,1.5 M3.5,17.5v-3.7 M15.5,10.7V1 M15.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M15.5,10.7  c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5 M15.5,17.5v-3.7 M9.5,4.7V1 M9.5,4.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M9.5,4.7  C8.7,4.7,8,5.4,8,6.2s0.7,1.5,1.5,1.5 M9.5,17.5V7.7"></path>
      </svg>
    </a>
    <form class="uk-form uk-align-right area-riservata__order uk-visible@l">
      <label>{{ $t('frontend-mtg.area_riservata.ordini.ordina_per') }}:</label>
      <select class="uk-select" id="" v-model="selectedFilter" @change="handleSelectChange">
        <option value="code" selected>{{ $t('frontend-mtg.area_riservata.ordini.select') }}</option>
        <option value="order_confirmation_date">{{ $t('frontend-mtg.area_riservata.ordini.date') }}</option>
        <option value="order_year">{{ $t('frontend-mtg.area_riservata.ordini.year') }}</option>
        <option value="code">{{ $t('frontend-mtg.area_riservata.ordini.number') }}</option>
        <option value="code_reference">{{ $t('frontend-mtg.area_riservata.ordini.reference') }}</option>
        <option value="process_status">{{ $t('frontend-mtg.area_riservata.ordini.progress') }}</option>
      </select>
    </form>
  </div>

</template>

<script>
export default {
  data() {
    return {
      count: 0,
      selectedFilter: null,
    }
  },
  computed: {
    filters(){
      return this.$store.state.grid.filters;
    }
  },
  mounted() {
  },
  methods: {
    handleSelectChange() {
      let direction = this.selectedFilter === 'code' ? 'DESC' : 'ASC';
      this.$store.commit('grid/setOrder', {column: this.selectedFilter, direction: direction});
    },
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/OrdersSorting.vue